import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch,faEdit, faArrowRotateLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useListarUsuariosConsultantesHistorico } from '../../hooks/useListarUsuariosConsultanteHistorico';

function UsuarioConsultanteHistoricoGrid(){
const columnas=[
    {
        name:'Nro',
        selector: row => row.Id,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.NombreCompleto,
        sorteable:true,
    
    },
    {
        name:'Telefono',
        selector:row => row.Telefono,
        sorteable:true
    },
    {
        name:'Correo',
        selector:row => row.Correo,
        sorteable:true,
        right:true
    },
    {
        name:'Acciones',
		cell: row => (
            <>
            <a href={'FichaUsuarioConsultante/'+row.Id} rel="noopener noreferrer" title='Visualizar/editar'>
            	<FontAwesomeIcon icon={faEdit}  />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onEnabled(row.Id)} rel="noopener noreferrer" title='Habilitar'>
            	<FontAwesomeIcon icon={faArrowRotateLeft} />
            </a>
            </>       
        )
    }
];
const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}

//Quizas ahi podria ir habilitarlos nuevamente, pero esperar decision funcional
const onEnabled=async n=>{
    
    confirmAlert({
        title: '',
        message: '¿Seguro desea habilitar al usuario consultante?',
        buttons: [
          {
            label: 'Si',
            onClick: () => enabledFichaConsultante(n)
          },
          {
            label: 'No'
            
          }
        ]
      });

}


 //function UsuarioConsultanteGrid(){
    const { usuariosConsultantesHistorico,getUsuariosConsultantesHistorico,enabledFichaConsultante } = useListarUsuariosConsultantesHistorico();
    const onChange=async e=>{
        e.persist();
        if(e.target.value.length>3){
            getUsuariosConsultantesHistorico(e.target.value);
        }
        else if(e.target.value.length==0){
            getUsuariosConsultantesHistorico();
        }
    }
   
   

        return (
            <div className='table-responsive'>
                <div className='barraBusqueda'>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="textField"
                        name="busqueda"
                        onChange={onChange}

                        
                    />
                    <button type='button' className='btnBuscar'>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>

            <DataTable
                columns={columnas}
                data={usuariosConsultantesHistorico}
                pagination
                paginationComponentOptions={paginacionOpciones}
                fixedHeader
                fixedHeaderScrollHeight='600px'
                noDataComponent="No hay elementos para mostrar"
                striped={true}
                
            />
            </div>


        )

    
}
export default UsuarioConsultanteHistoricoGrid;

